import React, { useState } from 'react';
import Text, {
  TEXT_COLOR,
  TEXT_KIND,
  TEXT_FONT_WEIGHT,
  TEXT_SIZE,
  TEXT_DISPLAY,
} from '@/bit/components/components.text';
import FormTemplate, { THEMES } from '@/components/formTemplate/index';
import { PAYMENT } from '@/constants/payment';
import Payment from '@/containers/payment';

function ClientPayment({ control, bankAccount = '', editable = true }) {
  const [isEditable, setIsEditable] = useState(!bankAccount);
  const handleEditAction = () => {
    setIsEditable(true);
  };
  const { TITLE, ID, BANK_ACCOUNT } = PAYMENT;
  return (
    <>
      {!isEditable && (
        <div className="client-payment-container">
          <FormTemplate
            titleText={TITLE}
            cyData={ID}
            theme={THEMES.LONG}
            action={
              editable
                ? {
                    onClick: handleEditAction,
                    label: 'Editar',
                  }
                : null
            }
          >
            <Text
              text={`${BANK_ACCOUNT.LABEL}: `}
              color={TEXT_COLOR.GREY6}
              kind={TEXT_KIND.SPAN}
              size={TEXT_SIZE.CAPTION2}
              display={TEXT_DISPLAY.INLINE}
              fontType={TEXT_FONT_WEIGHT.REGULAR}
            />
            <Text
              text={bankAccount}
              color={TEXT_COLOR.GREY5}
              kind={TEXT_KIND.SPAN}
              size={TEXT_SIZE.CAPTION2}
              display={TEXT_DISPLAY.INLINE}
              fontType={TEXT_FONT_WEIGHT.REGULAR}
            />
          </FormTemplate>
        </div>
      )}
      {isEditable && <Payment control={control} />}
      <style jsx>
        {`
          .client-payment-container {
            margin-bottom: 12px;
          }
        `}
      </style>
    </>
  );
}
export default ClientPayment;
